import React from "react";
import "./HowSecurityWorks.css";

function HowSecurityWorks() {
  const steps = [
    {
      number: "01",
      title: "Choose Security Type",
      description:
        "Select SSL, domain protection, account protection, or a general security enquiry.",
    },
    {
      number: "02",
      title: "Submit Your Request",
      description:
        "Fill the relevant form with your details, domain name, and message so the request is stored correctly.",
    },
    {
      number: "03",
      title: "Get Secure Support",
      description:
        "Your request is safely recorded and can be reviewed by the support or security team.",
    },
  ];

  return (
    <section className="hsw-section" id="security-how-it-works">
      <div className="hsw-container">
        <div className="hsw-heading">
          <span className="hsw-badge">How It Works</span>
          <h2>Simple Steps to Strengthen Your Security</h2>
          <p>
            A clean security workflow that avoids duplicate data and keeps user
            requests organized.
          </p>
        </div>

        <div className="hsw-grid">
          {steps.map((step, index) => (
            <div className="hsw-card" key={index}>
              <div className="hsw-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>

              {index !== steps.length - 1 && (
                <span className="hsw-arrow">→</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowSecurityWorks;